import { render, staticRenderFns } from "./LayoutContentVerticalNav.vue?vue&type=template&id=2d65d650&scoped=true"
import script from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js"
export * from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentVerticalNav.vue?vue&type=style&index=0&id=2d65d650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65d650",
  null
  
)

export default component.exports